import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import parseISO from 'date-fns/parseISO';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import QuickCard from '../QuickCard';
import QuickDataModal from '../QuickDataModal';
import { Modal } from 'antd';
import { DtcIcon } from '../../../../../../common/icons';

@inject('translationsStore', 'commonStore', 'pagedCollectionStore')
@observer
export default class QuickGroupDtcs extends Component {
  constructor(props) {
    super(props);

    const { translationsStore, commonStore } = this.props;

    this.emptyValue = '-';
    this.itemsPerPage = 7;
    this.namespacePrefix = 'dtcs';
    this.historicalFnName = 'historyDtc';
    this.liveColumns = [
      {
        key: 'code',
        dataIndex: 'code',
        title: translationsStore.translate('quickhealth.dtcs.liveColumns.code'),
        width: 100,
        render: (text, record) => {
          let style = { textDecoration: 'underline' };
          if (record.severity === 'red') {
            style = { ...style, color: 'var(--red-dtc-color)' };
          }
          if (record.severity === 'orange') {
            style = { ...style, color: 'var(--orange-dtc-color)' };
          }
          return <div style={style}><a style={style} onClick={e => {
            e.stopPropagation();
            this.showExtendedDTCs(record);
          }}>{text}</a></div>;
        },
        sorter: true
      },
      {
        key: 'description',
        dataIndex: 'description',
        title: translationsStore.translate('quickhealth.dtcs.liveColumns.description'),
        render: (text, record) => ((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).description || record.description
      },

      {
        key: 'lastReceivedAt',
        dataIndex: 'lastReceivedAt',
        title: translationsStore.translate('quickhealth.dtcs.liveColumns.lastReceivedAt'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return (
            <div style={style}>
              {text !== this.emptyValue ? formatDistanceToNow(parseISO(record.lastReceivedAt), { addSuffix: true, locale: commonStore.dateFnsLocale }) : this.emptyValue}
            </div>
          );
        },
        sorter: true
      },
      {
        key: 'lastOdometer',
        dataIndex: 'lastOdometer',
        title: translationsStore.translate('quickhealth.dtcs.liveColumns.lastOdometer'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.lastOdometer ? `${record.lastOdometer.toLocaleString(commonStore.momentLocale)} km` : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'km',
        dataIndex: 'km',
        title: translationsStore.translate('quickhealth.dtcs.liveColumns.km'),
        className: 'CenterNoWrap',
        width: 110,
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.km ? record.km.toLocaleString(commonStore.momentLocale) : this.emptyValue}</div>;
        },
        sorter: true
      }
    ];
    this.quickColumns = this.liveColumns.map(column => ({ ...column, sorter: false }));
    this.historicalColumns = [
      {
        key: 'code',
        dataIndex: 'code',
        title: translationsStore.translate('quickhealth.dtcs.historicalColumns.code'),
        width: 100,
        render: (text, record) => {
          let style = { textDecoration: 'underline' };
          if (record.severity === 'red') {
            style = { ...style, color: 'var(--red-dtc-color)' };
          }
          if (record.severity === 'orange') {
            style = { ...style, color: 'var(--orange-dtc-color)' };
          }
          return <div style={style}><a style={style} onClick={e => {
            e.stopPropagation();
            this.showExtendedDTCs(record);
          }}>{text}</a></div>;
        },
        sorter: true
      },
      {
        key: 'description',
        dataIndex: 'description',
        title: translationsStore.translate('quickhealth.dtcs.historicalColumns.description'),
        render: (text, record) => ((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).description || record.description
      },
      {
        key: 'recordedAt',
        dataIndex: 'recordedAt',
        title: translationsStore.translate('quickhealth.dtcs.historicalColumns.recordedAt'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue ? new Date(record.recordedAt).toLocaleDateString(commonStore.momentLocale) : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'initialOdometer',
        dataIndex: 'initialOdometer',
        title: translationsStore.translate('quickhealth.dtcs.historicalColumns.initialOdometer'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.initialOdometer ? `${record.initialOdometer.toLocaleString(commonStore.momentLocale)} km` : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'km',
        dataIndex: 'km',
        title: translationsStore.translate('quickhealth.dtcs.historicalColumns.km'),
        className: 'CenterNoWrap',
        width: 110,
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.km ? record.km.toLocaleString(commonStore.momentLocale) : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'resolvedAt',
        dataIndex: 'resolvedAt',
        title: translationsStore.translate('quickhealth.dtcs.historicalColumns.resolvedAt'),
        className: 'CenterNoWrap',
        width: 120,
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue ? new Date(record.resolvedAt).toLocaleDateString() : this.emptyValue}</div>;
        },
        sorter: true
      }
    ];

    this.defaultBase = {
      keyName: 'dtcs',
      color: 'var(--dark-grey)',
      caption: translationsStore.translate('quickhealth.dtcs.caption'),
      captionOne: translationsStore.translate('quickhealth.dtcs.captionOne'),
      icon: <DtcIcon style={{ width: '27px', height: '18px' }} />,
      ctaLabel: translationsStore.translate('quickhealth.dtcs.cta'),
      availableColumns: {
        current: this.liveColumns,
        quick: this.quickColumns,
        historical: this.historicalColumns
      },
      collection: undefined
    };

    this.showExtendedDTCs = record => {
      return (Modal.info({
        icon: <div />,
        title: <span class="bold">{translationsStore.translate('quickhealth.dtcs.extendedDescription')}</span>,
        width: 720,
        content: (
          <div style={{ paddingTop: '20px' }}>
            <p>
              <div class="bold">{translationsStore.translate('quickhealth.dtcs.subcategoryDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).subcategoryDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('quickhealth.dtcs.warningDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).warningDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('quickhealth.dtcs.recommendationDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).recommendationDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('quickhealth.dtcs.causeDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).causeDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('quickhealth.dtcs.effectDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).effectDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('quickhealth.dtcs.classification')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).classification || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
          </div>
        ),
        onOk() {},
      }));
    };

    this.state = {
      modal: {
        visible: false,
        onOk: this.handleToggleDetailed,
        onCancel: this.handleToggleDetailed
      }
    };
  }

  componentDidMount = () => {
    const { car } = this.props;
    if (!!car) {
      this.initCollections(car);
    }
  };

  componentDidUpdate = prevProps => {
    const { car } = this.props;
    if (!!car) {
      if ((!!prevProps.car && prevProps.car.id !== this.props.car.id) || !prevProps.car) {
        this.initCollections(car);
      }
    }
  };

  initCollections = car => {
    const { pagedCollectionStore } = this.props;
    let liveHelper = car.dtcs.slice().sort((a, b) => {
      return b.lastReceivedAt > a.lastReceivedAt ? 1 : -1;
    });
    pagedCollectionStore.init({ key: `${this.namespacePrefix}.current`, source: liveHelper, itemsPerPage: this.itemsPerPage, availableInTabs: true });
    pagedCollectionStore.init({ key: `${this.namespacePrefix}.quick`, source: liveHelper, limit: 2, availableInTabs: false });
    pagedCollectionStore.init({
      key: `${this.namespacePrefix}.historical`,
      source: { api: [this.historicalFnName, car.id] },
      itemsPerPage: this.itemsPerPage,
      availableInTabs: true
    });
  };

  handleToggleDetailed = () => {
    this.setState(previousState => ({ modal: { ...previousState.modal, visible: !previousState.modal.visible } }));
  };

  render() {
    const { modal } = this.state;

    const baseDetailed = { ...Object.assign({}, this.defaultBase), ctaLabel: undefined };
    const baseQuick = Object.assign({}, this.defaultBase, { rowThreshold: 2, collection: 'quick' });

    return (
      <Fragment>
        <QuickCard data={baseQuick} collection="quick" onShowDetailedClick={this.handleToggleDetailed} namespacedCollection={`${this.namespacePrefix}.quick`} />
        <QuickDataModal data={baseDetailed} modal={modal} namespacePrefix={this.namespacePrefix} />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickGroupDtcs/QuickGroupDtcs.js